const formatNumber = (num) => {
  if (num >= 1e9) return (num / 1e9).toFixed(2).replace(/\.0$/, '') + 'B';
  if (num >= 1e6) return (num / 1e6).toFixed(2).replace(/\.0$/, '') + 'M';
  if (num >= 1e3) return (num / 1e3).toFixed(2).replace(/\.0$/, '') + 'K';
  return String(num);
};

export default formatNumber;